import { render, staticRenderFns } from "./AdminProductCatalogue.vue?vue&type=template&id=6ffb317e&scoped=true"
import script from "./AdminProductCatalogue.vue?vue&type=script&lang=js"
export * from "./AdminProductCatalogue.vue?vue&type=script&lang=js"
import style0 from "./AdminProductCatalogue.vue?vue&type=style&index=0&id=6ffb317e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb317e",
  null
  
)

export default component.exports